<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="description" content="BlueYard x Nimi — Investing in founders creating the fabric of our future with open-source AI." />
    <meta property="og:type" content="website" />
    <meta property="og:title" content="BlueYard x Nimi" />
    <meta property="og:description" content="Investing in founders creating the fabric of our future with open-source AI." />
    <meta property="og:url" content="https://nimi.ai/blueyard.html" />
    <meta property="og:image" content="https://nimi.ai/og-image.png" />
    <meta name="twitter:card" content="summary" />
    <meta name="twitter:title" content="BlueYard x Nimi" />
    <meta name="twitter:description" content="Investing in founders creating the fabric of our future with open-source AI." />
    <link rel="canonical" href="https://nimi.ai/blueyard.html" />
    <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
    <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
    <link rel="icon" href="/favicon.ico" sizes="any" />
    <title>BlueYard x Nimi | Open-Source AI Runtime</title>
  </head>
  <body>
    <div id="root"></div>
    <script type="module" src="/src/landing/blueyard-main.tsx"></script>
  </body>
</html>
